import { get } from 'lodash';
import { MiniPlayer } from './MiniPlayer';
import { getPlayerAPI } from '../../initSkin';
import { getTypeOfContent } from '../../utils/getTypeOfContent';

export default createListeners;

const zones = [
  {
    get container() {
      return document.getElementById('safe_zone');
    },
  },
  {
    // Root interactive container, should hide as same as other
    get container() {
      return document.getElementById('mggp-interactive-container');
    },
  },
];

function createListeners(player, onUpdate, getState) {
  const miniPlayer = new MiniPlayer(player.config.videoContainer);

  // remote events registration:
  player.emit('register_remote_event', 'interactive:seek');

  player.on('interactive:hideElement', hideElement);
  player.on('interactive:showElement', showElement);
  player.on('interactive:paused', onPaused);
  player.on('interactive:resumed', onResume);
  player.on('interactive:started', onResume);
  player.on('interactive:seek', onSeek);

  function onSeek(event) {
    const { channelState, stream, channel } = getState();

    getPlayerAPI().playerMethods.seek(
      event.data.time,
      channelState,
      getTypeOfContent(stream),
      get(stream, 'content_type'),
      channel ? channel.type : undefined
    );
  }

  function onPaused(/*event*/) {
    zones.forEach((zone) => {
      zone.container.style.visibility = 'hidden';
    });
    miniPlayer.suspend();
  }

  function onResume(/*event*/) {
    zones.forEach((zone) => {
      zone.container.style.visibility = 'visible';
    });
    miniPlayer.restore();
  }

  /**
   * @param {module:MggpPluginInteractive~event:ShowElementEvent} event
   * @listens module:MggpPluginInteractive~event:ShowElementEvent
   */
  function hideElement(event) {
    const { element } = event.data;

    if (element.element_type === 'fullscreen') {
      setFullscreenForeground(false);
      player.set('interactive:fullscreen', false);
      window.dispatchEvent(new CustomEvent('interactiveenter'));
      miniPlayer.dispose();

      //MHP-2065
      player.config.container.focus({
        preventScroll: true,
        focusVisible: false,
      });
    }
  }

  /**
   * @param {module:MggpPluginInteractive~event:ShowElementEvent} event
   * @listens module:MggpPluginInteractive~event:ShowElementEvent
   */
  function showElement(event) {
    const { element } = event.data;

    if (element.element_type === 'fullscreen') {
      setFullscreenForeground(true);
      player.set('interactive:fullscreen', true);
      window.dispatchEvent(new CustomEvent('interactiveleave'));

      const state = getState();
      const isMiniPlayerDisabled =
        player.get('smallMode') || Boolean(state.messageModeData);

      if (element.mode === 'mini-player' && !isMiniPlayerDisabled) {
        miniPlayer.apply(element.parameters);
      }
    }
  }
}

/**
 * Control fullscreen element focusing, clickable, etc., via manipulate css variable.
 * Affect layout via inline styles of InteractiveLayer
 * @see {@link InteractiveLayer}
 * @todo Implement less junk approach.
 * @param {boolean} isForeground
 */
function setFullscreenForeground(isForeground) {
  document.documentElement.style.setProperty(
    '--interactive-layer-events',
    isForeground ? 'all' : 'none'
  );
  document.documentElement.style.setProperty(
    '--interactive-layer-zindex',
    isForeground ? '10' : 'initial'
  );
}
